import { apiClient } from '@/lib/api-client';

/** Ops simulation T16 — an owner sets or removes a staff member's POS PIN. */
export const posPinService = {
  getStatus(userId: string) {
    return apiClient<{ has_pin: boolean }>(`/manager-approval/pin/${userId}`);
  },

  set(userId: string, pin: string) {
    return apiClient<{ has_pin: true }>(`/manager-approval/pin/${userId}`, {
      method: 'PUT',
      body: { pin },
    });
  },

  clear(userId: string) {
    return apiClient<{ has_pin: false }>(`/manager-approval/pin/${userId}`, {
      method: 'DELETE',
    });
  },
};
